import { PageRoutes } from "@/enums/routes.enum";
import {
  BookOpenIcon,
  ChatBubbleOvalLeftEllipsisIcon,
  DocumentTextIcon,
  HomeIcon,
  ShoppingBagIcon,
  UsersIcon,
  LockClosedIcon,
  UserGroupIcon,
  ChatBubbleLeftRightIcon,
  Cog6ToothIcon,
  ShoppingCartIcon,
  DocumentChartBarIcon,
} from "@heroicons/react/24/solid";
import { MdOutlineInventory2 } from "react-icons/md";

export const mainMenu = [
  {
    name: "Dashboard",
    hasSubmenu: false,
    href: PageRoutes.DASHBOARD,
    icon: HomeIcon,
    roles: ["Superadmin"],
    permission: "menu-dashboard",
  },
  {
    name: "Chat",
    hasSubmenu: false,
    href: PageRoutes.CHAT,
    icon: ChatBubbleLeftRightIcon,
    roles: ["Superadmin"],
    permission: "menu-chat",
    count: 0
  },

  {
    name: "Users",
    hasSubmenu: false,
    href: PageRoutes.USERS,
    icon: UsersIcon,
    roles: ["Superadmin"],
    permission: "menu-user",
  },

  {
    name: "Courses",
    hasSubmenu: false,
    href: PageRoutes.COURSES,
    icon: BookOpenIcon,
    roles: ["Superadmin"],
    permission: "menu-course",
  },
  {
    name: "Roles",
    href: PageRoutes.ROLES,
    icon: UserGroupIcon,
    roles: ["Superadmin"],
    permission: "menu-role",
  },
  {
    name: "Permissions",
    href: PageRoutes.PERMISSIONSETTINGS,
    icon: LockClosedIcon,
    roles: ["Superadmin"],
    permission: "menu-permission",
  },

  {
    name: "Tickets",
    hasSubmenu: false,
    href: PageRoutes.TICKETS,
    icon: DocumentTextIcon,
    roles: ["Superadmin"],
    permission: "menu-ticket",
  },
  {
    name: "Document Report",
    hasSubmenu: false,
    href: PageRoutes.DOCUMENTREPORT,
    icon: DocumentChartBarIcon,
    roles: ["Superadmin"],
    permission: "menu-document-report",
  },
  {
    name: "Feedback",
    hasSubmenu: false,
    href: PageRoutes.FEEDBACK,
    icon: ChatBubbleOvalLeftEllipsisIcon,
    roles: ["Superadmin"],
    permission: "menu-feedback",
  },
  {
    name: "Settings",
    hasSubmenu: false,
    href: PageRoutes.SETTINGS,
    icon: Cog6ToothIcon,
    roles: ["Superadmin"],
    permission: "menu-settings",
  },
  {
    name: "Purchase Order",
    hasSubmenu: false,
    href: PageRoutes.PURCHASE_ORDER,
    icon: ShoppingCartIcon,
    roles: ["Superadmin"],
    permission: "menu-purchase-order",
  },
  {
    name: "Inventories",
    hasSubmenu: false,
    href: PageRoutes.INVENTORIES,
    icon: MdOutlineInventory2,
    roles: ["Superadmin"],
    permission: "menu-inventory",
  },
  {
    name: 'Inventoy Items',
    hasSubmenu: false,
    href: '/inventory-items',
    roles: ['Superadmin'],
    permission: "menu-inventory",
    icon: MdOutlineInventory2,

  }
  
];

export const secondaryMenu = [
  {
    name: "Form",
    hasSubmenu: true,
    subMenu: [
      {
        name: "Application Forms",
        href: PageRoutes.APPLICATION,
        icon: DocumentTextIcon,
        roles: ["Superadmin"],
        permission: "menu-application-form",
      },
      {
        name: "Orientation Forms",
        href: PageRoutes.ENROLLMENT,
        icon: DocumentTextIcon,
        roles: ["Superadmin"],
        permission: "menu-enrollment-form",
      },

      {
        name: "Re-Enrollment",
        href: PageRoutes.REENROLLMENT,
        icon: DocumentTextIcon,
        roles: ["Superadmin"],
        permission: "menu-reenrollment-form",
      },

      {
        name: "Change of Address",
        href: PageRoutes.CHANGEOFADDRESS,
        icon: DocumentTextIcon,
        roles: ["Superadmin"],
        permission: "menu-change-of-address-form",
      },

      {
        name: "Variation of Course/Intake Form",
        href: PageRoutes.VARIATIONOFCOURSE,
        icon: DocumentTextIcon,
        roles: ["Superadmin"],
        permission: "menu-variation-form",
      },

      {
        name: "Internal Transfer",
        href: PageRoutes.INTERNALTRANSFER,
        icon: DocumentTextIcon,
        //roles: ["Superadmin", "Admin", "Student"],
        roles: ["Superadmin"],
        permission: "menu-internal-transfer-form",
      },
      {
        name: "Request of Information",
        href: PageRoutes.REQUESTOFINFORMATION,
        icon: DocumentTextIcon,
        //roles: ["Superadmin", "Admin", "Student", "Account"],
        roles: ["Superadmin"],
        permission: "menu-request-of-information-form",
      },
      {
        name: "Student Intervention",
        href: PageRoutes.STUDENTINTERVENTION,
        icon: DocumentTextIcon,
        // roles: ["Superadmin", "Admin", "Trainer"],
        roles: ["Superadmin"],
        permission: "menu-student-intervention-form",
      },
      {
        name: "Credit Transfer",
        href: PageRoutes.CREDITTRANSFER,
        icon: DocumentTextIcon,
        //roles: ["Superadmin", "Admin", "Student", "Account", "Trainer"],
        roles: ["Superadmin"],
        permission: "menu-credit-transfer-form",
      },
      {
        name: "Defer Suspend Cancel Enrolment",
        href: PageRoutes.DSRCENROLMENT,
        icon: DocumentTextIcon,
        // roles: ["Superadmin", "Admin", "Student", "Account", "Trainer"],
        roles: ["Superadmin"],
        permission: "menu-defer-form",
      },
      {
        name: "Overseas Travel",
        href: PageRoutes.OVERSEASTRAVEL,
        icon: DocumentTextIcon,
        // roles: ["Superadmin", "Admin", "Student", "Account", "Trainer"],
        roles: ["Superadmin"],
        permission: "menu-overseas-form",
      },
      {
        name: "Certificate Application",
        href: PageRoutes.CERTIFICATEAPPLICATION,
        icon: DocumentTextIcon,
        //roles: ["Superadmin", "Admin", "Account", "Trainer", "Student"],
        roles: ["Superadmin"],
        permission: "menu-certificate-application-form",
      },
      {
        name: "Complaints and Appeals Form",
        href: PageRoutes.COMPLAINTSAPPEALS,
        icon: DocumentTextIcon,
        // roles: ["Superadmin", "Admin", "Account", "Trainer", "Student"],
        roles: ["Superadmin"],
        permission: "menu-complaints-appeals-form",
      },
    ],
  },

  {
    name: "Short Course",
    hasSubmenu: true,
    subMenu: [
      {
        name: "Short Courses",
        href: PageRoutes.SHORTCOURSES,
        icon: BookOpenIcon,
        roles: ["Superadmin"],
        permission: "menu-short-course",
      },
      {
        name: "Short Course Order",
        href: PageRoutes.SHORTCOURSESORDER,
        icon: ShoppingBagIcon,
        roles: ["Superadmin"],
        permission: "menu-short-course-order",
      },
    ],
  },
];
